var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40004461_1103)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40004461_1103",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H22V22H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40004461_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 11C21.3555 16.7192 16.7191 21.3555 11 21.3555C5.28073 21.3555 0.644531 16.7192 0.644531 11C0.644531 5.28073 5.28073 0.644533 11 0.644533C16.7191 0.644533 21.3555 5.28073 21.3555 11Z",
    stroke: "#0A0F0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1421 9.61953C15.1421 11.9072 13.2876 13.7617 10.9999 13.7617C8.71207 13.7617 6.85767 11.9072 6.85767 9.61953C6.85767 7.33192 8.71207 5.47739 10.9999 5.47739C13.2876 5.47739 15.1421 7.33192 15.1421 9.61953Z",
    stroke: "#0A0F0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82153 19.3114C5.15282 16.1918 7.79248 13.7617 10.9999 13.7617C14.2074 13.7617 16.847 16.192 17.1781 19.3115",
    stroke: "#0A0F0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40004461_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.d272229f2e23bd15dbc6cc50a0fbc1b1.svg";
export { ForwardRef as ReactComponent };